import React, { useEffect, useState } from "react";
import SavingsTable from "./SavingsTable";
import TopDCom from "./TopDCom";
import getServices from "../../Services/get-service";
import ButtonPlus from "../SelectValue/ButtonPlus";
import SetRate from "./SetRate";
import CreateSavingsCategory from "./SetRate";

function MainCon() {
  const [totalActiveSavingPlan, setTotalActiveSavingsPlan] = useState("0");
  const [totalAmountSaved, setTotalAmountSaved] = useState("0");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // omni
  const [totalAmountWithdrawn, setTotalAmountWithdrawn] = useState("0");
  useEffect(() => {
    getServices.getAllCount().then(
      (response) => {
        if (response.data.status === "2000") {
          setTotalAmountWithdrawn(
            response.data.data.totalwithdrawalAmount || 0
          );
          setTotalActiveSavingsPlan(
            response.data.data.totalActiveSavingsPlan || 0
          );
          setTotalAmountSaved(response.data.data.totalAmountSaved || 0);
        } else {
          //  swal(response.data.description)
          //  toast('Session Expired', {
          //   onClose: () => {
          //       window.location.href = '/'
          //   },
          //   autoClose: 5000
          // })
        }
        console.log(response.data.data);
      },
      (error) => {}
    );
  }, []);
  return (
    <div>

      
      <div className="flex flex-col sm:flex-row justify-between gap-2 sm:gap-0">
        <p className="text-text text-xl">Filter Savings</p>
        <div
          className=""
        >
         <CreateSavingsCategory open={open} handleClose={handleClose} />
        <ButtonPlus name={"Add new savings category"} onClick={handleOpen} />
        </div>
      </div>

      <div>
        <SavingsTable />
      </div>

      
    </div>
  );
}

export default MainCon;
